import { Navigate, useParams, useSearchParams } from "react-router-dom";

import { PageDirectoryEntryName } from "../api/PageDirectory";
import { useAuth } from "../providers/AuthProvider";

const CrmLinkRouter = () => {
  const { destinationId } = useParams();
  const [searchParams] = useSearchParams();
  const { getScopedPageUrl } = useAuth();
  const id = searchParams.get("id");

  searchParams.delete("id");
  const newParams = searchParams.toString();

  if (!destinationId) {
    // TODO: improve client side error messaging
    throw new Error("destination id param is misisng");
  }

  if (!id) {
    // TODO: improve client side error messaging
    throw new Error("id query param are missing");
  }

  return (
    <Navigate
      to={`${getScopedPageUrl(
        destinationId as PageDirectoryEntryName,
        id
      )}?${newParams}`}
    />
  );
};

export default CrmLinkRouter;
